
// import React from 'react';

// const CrownVillas = () => {
//   return (
//     <div className="crown villas">
//       {/* Premium Hero Section */}
//       <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#E8E2D5]">
//         <div className="container mx-auto px-4 lg:px-8 py-20">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-7xl mx-auto mb-20">
//             {/* Left - Hillside Villa */}
//             <div className="relative aspect-[4/5] rounded-none overflow-hidden shadow-2xl">
//               <img 
//                 src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80" 
//                 alt="The Crown Villas - East Facing"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             {/* Right - Oceanfront Villa */}
//             <div className="relative aspect-[16/10] rounded-none overflow-hidden shadow-2xl">
//               <img 
//                 src="https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=1200&q=80" 
//                 alt="The Crown Villas - West Facing"
//                 className="w-full h-full object-cover"
//               />
//             </div>
//           </div>

//           {/* Hero Content */}
//           <div className="max-w-7xl mx-auto">
//             <div className="text-center mb-12">
//               <div className="inline-block mb-6">
//                 <div className="w-20 h-[2px] bg-luxury-accent mx-auto"></div>
//               </div>
//               <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
//                 The Crown Villas
//               </h1>
//               <p className="text-2xl lg:text-3xl text-luxury-primary/90 mb-6 font-light">
//                 125 Exclusive Villas in 8.7 Acres
//               </p>
//               <p className="text-xl text-luxury-primary/70 max-w-3xl mx-auto leading-relaxed">
//                 Rameshwar Banda Village, Patancheru Mandal, Sangareddy District
//               </p>
//             </div>

//             {/* Premium Financing Badge */}
//             <div className="flex justify-center">
//               <div className="relative group">
//                 <div className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-luxury-primary opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300"></div>
//                 <div className="relative bg-white border border-luxury-accent/20 rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
//                   <div className="text-center">
//                     <p className="text-luxury-primary/60 text-xs uppercase tracking-[0.3em] mb-4 font-medium">
//                       Project Financed By
//                     </p>
//                     <h3 className="font-serif text-3xl lg:text-4xl font-bold text-luxury-dark mb-3">
//                       Capri Global Capital Limited
//                     </h3>
//                     <div className="inline-flex items-center gap-2 bg-luxury-accent/10 px-6 py-2 rounded-sm">
//                       <svg className="w-4 h-4 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                       </svg>
//                       <p className="text-luxury-accent font-semibold uppercase text-sm tracking-wider">
//                         Authorized Financial Partner
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//           <svg className="w-6 h-6 text-luxury-primary/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//           </svg>
//         </div>
//       </section>

//       {/* Project Overview */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
//             <div>
//               <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//                 About The Project
//               </span>
//               <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
//                 Experience<br />Royal Living
//               </h2>
//               <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
//                 <p>
//                   The Crown Villas project is an 8.7 acre development of 125 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. Today it is a calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy, which is the District Headquarters.
//                 </p>
//                 <p>
//                   This prestigious development offers a perfect blend of tranquility and accessibility, providing residents with a serene living environment while maintaining convenient connectivity to major urban centers.
//                 </p>
//               </div>

//               {/* Key Features */}
//               <div className="grid grid-cols-2 gap-6 mt-12">
//                 <div className="bg-luxury-bg p-6 rounded-lg">
//                   <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">8.7</div>
//                   <p className="text-luxury-primary font-semibold">Acres of Land</p>
//                 </div>
//                 <div className="bg-luxury-bg p-6 rounded-lg">
//                   <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">125</div>
//                   <p className="text-luxury-primary font-semibold">Exclusive Villas</p>
//                 </div>
//                 <div className="bg-luxury-bg p-6 rounded-lg">
//                   <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">6 km</div>
//                   <p className="text-luxury-primary font-semibold">From Patancheru</p>
//                 </div>
//                 <div className="bg-luxury-bg p-6 rounded-lg">
//                   <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">30 km</div>
//                   <p className="text-luxury-primary font-semibold">From Sangareddy</p>
//                 </div>
//               </div>
//             </div>

//             <div className="relative">
//               <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80" 
//                   alt="Crown Villas"
//                   className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
//                 />
//               </div>
//               <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-luxury-accent/10 rounded-2xl -z-10"></div>
//               <div className="absolute -top-8 -left-8 w-48 h-48 bg-luxury-primary/10 rounded-full -z-10"></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Royal Oak Mention */}
//       <section className="py-20 bg-gradient-to-br from-luxury-accent/10 via-luxury-bg to-luxury-primary/10">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-4xl mx-auto text-center">
//             <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-12 shadow-xl">
//               <div className="w-16 h-16 bg-luxury-accent rounded-full flex items-center justify-center mx-auto mb-6">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">Coming Soon: Royal Oak</h3>
//               <p className="text-lg text-luxury-primary leading-relaxed mb-4">
//                 Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ).
//               </p>
//               <p className="text-luxury-primary">
//                 Phase 1 launching soon with premium villa developments.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* East Facing Villas Section */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//               <div className="space-y-8">
//                 <div>
//                   <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                     EAST ORIENTATION
//                   </span>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
//                     East Facing Villas
//                   </h2>
//                   <p className="text-xl text-luxury-primary/80 leading-relaxed">
//                     East-facing villas are a popular choice for many homeowners, offering abundant morning sunlight and natural brightness.
//                   </p>
//                 </div>

//                 <div className="space-y-6 pt-4">
//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Benefits</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       One of the main benefits of an East-facing villa is that it receives plenty of morning sunlight, which can help to brighten up the interior of the home. This can be especially appealing for those who enjoy starting their day with some natural light. Additionally, East-facing homes often have a cooler temperature, as they are sheltered from the hot afternoon sun.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design Considerations</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       When designing an East-facing villa, it's important to consider the orientation of the home in relation to the sun. Windows and outdoor living spaces should be placed on the East side to take advantage of the morning sun. Shading elements such as awnings or overhangs protect against the hot afternoon sun.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Landscaping & Outdoor Living</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       East-facing villas have beautiful outdoor spaces that can be enjoyed in the morning and early afternoon. This includes patios, decks, and gardens oriented to the East. Landscaping features trees and plants chosen to thrive in morning sun and provide shade in the afternoon.
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="relative">
//                 <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
//                   <img 
//                     src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80" 
//                     alt="East Facing Villa"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="absolute top-6 right-6 bg-white px-6 py-3 rounded-sm shadow-lg">
//                   <div className="flex items-center gap-3">
//                     <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
//                     </svg>
//                     <span className="font-medium text-luxury-dark">Morning Sun</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* West Facing Villas Section */}
//       <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//               <div className="relative order-2 lg:order-1">
//                 <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
//                   <img 
//                     src="https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800&q=80" 
//                     alt="West Facing Villa"
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <div className="absolute top-6 left-6 bg-white px-6 py-3 rounded-sm shadow-lg">
//                   <div className="flex items-center gap-3">
//                     <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
//                     </svg>
//                     <span className="font-medium text-luxury-dark">Evening Sun</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-8 order-1 lg:order-2">
//                 <div>
//                   <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                     WEST ORIENTATION
//                   </span>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
//                     West Facing Villas
//                   </h2>
//                   <p className="text-xl text-luxury-primary/80 leading-relaxed">
//                     As a company that specializes in building West-facing villas, we have developed a process to ensure that each home meets the highest standards of quality and craftsmanship.
//                   </p>
//                 </div>

//                 <div className="space-y-6 pt-4">
//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design and Planning</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       We work closely with our clients to understand their needs and preferences, creating custom designs that reflect their personal style and meet functional requirements while considering local zoning laws and regulations.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Land Acquisition</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       Once the design is finalized, we work to acquire the land on which it will be built. This may involve purchasing from individual owners or working with developers on larger parcels.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Construction & Finishing</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       We use high-quality materials and techniques to ensure longevity. Finishing touches include custom features like hardwood floors, granite countertops, and carefully designed landscaping.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Interior Showcase - Green Haven Style */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="mb-16">
//               <div className="flex items-end justify-between mb-8">
//                 <div>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-4">
//                     Green Haven Office Park
//                   </h2>
//                   <p className="text-xl text-luxury-primary/70">
//                     Price <span className="font-serif text-3xl font-bold text-luxury-dark ml-2">$1.2M</span>
//                   </p>
//                 </div>
//                 <button className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-luxury-dark hover:bg-luxury-dark hover:text-white transition-all duration-300 rounded-sm">
//                   <span className="font-medium">View Now</span>
//                   <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                   </svg>
//                 </button>
//               </div>

//               <div className="flex items-center gap-8 text-luxury-primary/70 text-lg flex-wrap">
//                 <span>3,900 sq. ft.</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>3 Bedroom</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>3 Bathroom</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>Sunset View</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>Swimming Pool</span>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//               {/* Living Room */}
//               <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80" 
//                   alt="Modern living room with floor-to-ceiling windows"
//                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
//                 />
//               </div>

//               {/* Bathroom */}
//               <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80" 
//                   alt="Minimalist bathroom with freestanding tub"
//                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Comparison Section */}
//       <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="text-center mb-16">
//               <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                 COMPARISON
//               </span>
//               <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
//                 East vs West: Making the Right Choice
//               </h2>
//               <p className="text-xl text-luxury-primary/80 max-w-3xl mx-auto">
//                 Understanding the differences to choose your perfect villa
//               </p>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
//               {/* Sun Exposure */}
//               <div className="bg-white rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
//                 <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-8 mx-auto">
//                   <svg className="w-8 h-8 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
//                   </svg>
//                 </div>
//                 <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-6 text-center">Sun Exposure</h4>
//                 <div className="space-y-5">
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">East Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">Plenty of morning sunlight, brightening interiors and creating a warm, welcoming atmosphere.</p>
//                   </div>
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">West Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">More afternoon and evening sunlight, creating a warm and cozy atmosphere in the evenings.</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Temperature */}
//               <div className="bg-white rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
//                 <div className="w-16 h-16 bg-luxury-primary/10 rounded-full flex items-center justify-center mb-8 mx-auto">
//                   <svg className="w-8 h-8 text-luxury-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                   </svg>
//                 </div>
//                 <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-6 text-center">Temperature</h4>
//                 <div className="space-y-5">
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">East Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">Often cooler, sheltered from the hot afternoon sun, ideal for comfortable daytime living.</p>
//                   </div>
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">West Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">Warmer in evenings due to longer periods of afternoon and evening sunlight exposure.</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Outdoor Living */}
//               <div className="bg-white rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
//                 <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-8 mx-auto">
//                   <svg className="w-8 h-8 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//                   </svg>
//                 </div>
//                 <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-6 text-center">Outdoor Living</h4>
//                 <div className="space-y-5">
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">East Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">Outdoor spaces oriented to enjoy morning sun, perfect for breakfast and early afternoon activities.</p>
//                   </div>
//                   <div>
//                     <p className="font-semibold text-luxury-accent mb-2">West Facing:</p>
//                     <p className="text-luxury-primary/80 text-sm leading-relaxed">Outdoor spaces designed for evening enjoyment, ideal for sunset views and dinner gatherings.</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-white rounded-sm p-12">
//               <p className="text-center text-luxury-primary/90 text-lg leading-relaxed">
//                 <span className="font-semibold text-luxury-dark">Landscaping Tip:</span> Both orientations require thoughtful landscaping with trees and plants chosen to thrive in the appropriate amount of sunlight, ensuring year-round beauty and comfort.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Floor Plans Section */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Villa Designs
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Floor Plans
//             </h2>
//             <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
//               Detailed drawings that show the layout of each villa, including dimensions, room placements, and the location of doors, windows, and other features.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
//             {/* Floor Plan Cards */}
//             {[
//               { title: 'Ground Floor Plan', beds: '3 BHK', size: '2000 sq.ft' },
//               { title: 'First Floor Plan', beds: '4 BHK', size: '2500 sq.ft' },
//               { title: 'Duplex Villa Plan', beds: '5 BHK', size: '3500 sq.ft' },
//             ].map((plan, index) => (
//               <div key={index} className="bg-white rounded-sm overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 group border border-luxury-accent/10">
//                 <div className="aspect-[4/3] bg-gradient-to-br from-[#E8E2D5] to-white flex items-center justify-center relative overflow-hidden p-8">
//                   {/* Simplified floor plan illustration */}
//                   <div className="w-full h-full border-2 border-luxury-primary/20 rounded-sm relative">
//                     <div className="absolute top-4 left-4 right-4 h-16 border border-luxury-primary/30"></div>
//                     <div className="absolute top-24 left-4 w-20 h-20 border border-luxury-primary/30"></div>
//                     <div className="absolute top-24 right-4 w-20 h-20 border border-luxury-primary/30"></div>
//                     <div className="absolute bottom-4 left-4 right-4 h-24 border border-luxury-primary/30"></div>
//                   </div>
//                   <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-sm shadow-lg">
//                     <span className="text-luxury-accent font-semibold text-sm">{plan.beds}</span>
//                   </div>
//                 </div>
//                 <div className="p-6">
//                   <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{plan.title}</h3>
//                   <div className="flex items-center justify-between text-luxury-primary mb-6">
//                     <span className="text-sm">Built-up Area</span>
//                     <span className="font-semibold">{plan.size}</span>
//                   </div>
//                   <button className="w-full px-6 py-3 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-colors duration-300">
//                     View Details
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Download Brochure Button */}
//           <div className="text-center mt-16">
//             <button className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//               </svg>
//               Download Complete Brochure
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Quality Standards */}
//       <section className="py-20 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-6xl mx-auto">
//             <div className="text-center mb-16">
//               <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//                 Quality & Craftsmanship
//               </h2>
//               <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
//                 Each home we build meets the highest standards of quality and craftsmanship
//               </p>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {[
//                 {
//                   title: 'Premium Materials',
//                   desc: 'High-quality materials and construction techniques ensuring durability and longevity',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Custom Designs',
//                   desc: 'Personalized designs that reflect your style while meeting functional requirements',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Expert Team',
//                   desc: 'Skilled engineers and contractors with extensive experience in villa construction',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Thoughtful Landscaping',
//                   desc: 'Beautiful outdoor spaces designed to complement your villa and enhance living experience',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
//                     </svg>
//                   )
//                 },
//               ].map((item, index) => (
//                 <div key={index} className="flex gap-6 bg-white p-8 rounded-sm hover:-translate-y-1 transition-all duration-300 hover:shadow-lg">
//                   <div className="flex-shrink-0 w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center text-luxury-accent">
//                     {item.icon}
//                   </div>
//                   <div>
//                     <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{item.title}</h3>
//                     <p className="text-luxury-primary leading-relaxed">{item.desc}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10">
//           <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//         </div>

//         <div className="container mx-auto px-4 text-center relative z-10">
//           <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
//             Ready to Own Your Crown Villa?
//           </h2>
//           <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
//             Schedule a site visit today and experience the luxury of The Crown Villas
//           </p>
//           <div className="flex flex-col sm:flex-row gap-6 justify-center">
//             <a
//               href="/contact"
//               className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               Schedule Site Visit
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//             </a>
//             <a
//               href="tel:+919584646464"
//               className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-sm border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//               </svg>
//               Call Now
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default CrownVillas;


// import React, { useRef, useState, useEffect } from 'react';

// import gate1 from '../Assets/GATE VIEW -  (1).jpg';
// import gate2 from '../Assets/GATE VIEW -  (2).jpg';
// import clubhouse from '../Assets/CLUB HOUSE ELVATION -  (1).jpg';
// import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';
// import clubhouse3 from '../Assets/CLUB HOUSE ELVATION -  (3).jpg';
// import clubhouse4 from '../Assets/CLUB HOUSE LANDSCAPE -  (1).jpg';
// import clubhouse5 from '../Assets/CLUB HOUSE LANDSCAPE -  (2).jpg';


// const RevealImage = ({ src, alt, className = "" }) => {
//   const wrapperRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setIsRevealed(true);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.3 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
//       <img 
//         src={src} 
//         alt={alt} 
//         className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
//           isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
//         }`}
//         style={{ transitionDelay: '800ms' }}
//       />
      
//       {/* PURE SILVER Gradient Mask */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
//           isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
//         }`}
//         style={{ 
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
//           background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
//         }}
//       />
      
//       {/* Silver Shimmer */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
//           isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
//         }`}
//         style={{ 
//           transitionDelay: '300ms',
//           background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
//         }}
//       />
//     </div>
//   );
// };

// const RevealContent = ({ children, className = "", delay = 0 }) => {
//   const contentRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = contentRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setTimeout(() => {
//               setIsRevealed(true);
//             }, delay);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, [delay]);
  
//   return (
//     <div 
//       ref={contentRef} 
//       className={`transition-all duration-1000 ${
//         isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
//       } ${className}`}
//       style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
//     >
//       {children}
//     </div>
//   );
// };

// const CrownVillas = () => {
//   return (
//     <div className="crown-villas">
//       {/* Premium Hero Section */}
//       <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#E8E2D5]">
//         <div className="container mx-auto px-4 lg:px-8 py-20">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-7xl mx-auto mb-20">
//             {/* Left - Hillside Villa */}
//             <RevealContent delay={100}>
//               <div className="relative aspect-[4/5] rounded-none overflow-hidden shadow-2xl">
//                 <RevealImage
//                   src={gate1}
//                   alt="The Crown Villas - East Facing"
//                   className="w-full h-full"
//                 />
//               </div>
//             </RevealContent>

//             {/* Right - Oceanfront Villa */}
//             <RevealContent delay={200}>
//               <div className="relative aspect-[16/10] rounded-none overflow-hidden shadow-2xl">
//                 <RevealImage
//                   src={gate2}
//                   alt="The Crown Villas - West Facing"
//                   className="w-full h-full"
//                 />
//               </div>
//             </RevealContent>
//           </div>

//           {/* Hero Content */}
//           <div className="max-w-7xl mx-auto">
//             <RevealContent delay={300} className="text-center mb-12">
//               <div className="mb-6">
//                 <div className="inline-block w-20 h-[2px] bg-luxury-accent mx-auto"></div>
//               </div>
//               <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
//                 The Crown Villas
//               </h1>
//               <p className="text-2xl lg:text-3xl text-luxury-primary/90 mb-6 font-light">
//                 125 Exclusive Villas in 8.7 Acres
//               </p>
//               <p className="text-xl text-luxury-primary/70 max-w-3xl mx-auto leading-relaxed">
//                 Rameshwar Banda Village, Patancheru Mandal, Sangareddy District
//               </p>
//             </RevealContent>

//             {/* Premium Financing Badge */}
//             <RevealContent delay={400} className="flex justify-center">
//               <div className="relative group">
//                 <div className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-luxury-primary opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300"></div>
//                 <div className="relative bg-white border border-luxury-accent/20 rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
//                   <div className="text-center">
//                     <p className="text-luxury-primary/60 text-xs uppercase tracking-[0.3em] mb-4 font-medium">
//                       Project Financed By
//                     </p>
//                     <h3 className="font-serif text-3xl lg:text-4xl font-bold text-luxury-dark mb-3">
//                       Capri Global Capital Limited
//                     </h3>
//                     <div className="inline-flex items-center gap-2 bg-luxury-accent/10 px-6 py-2 rounded-sm">
//                       <svg className="w-4 h-4 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                       </svg>
//                       <p className="text-luxury-accent font-semibold uppercase text-sm tracking-wider">
//                         Authorized Financial Partner
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </RevealContent>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//           <svg className="w-6 h-6 text-luxury-primary/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//           </svg>
//         </div>
//       </section>

//       {/* Project Overview */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
//             <RevealContent delay={100}>
//               <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//                 About The Project
//               </span>
//               <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
//                 Experience<br />Royal Living
//               </h2>
//               <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
//                 <p>
//                   The Crown Villas project is an 8.7 acre development of 125 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. Today it is a calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy, which is the District Headquarters.
//                 </p>
//                 <p>
//                   This prestigious development offers a perfect blend of tranquility and accessibility, providing residents with a serene living environment while maintaining convenient connectivity to major urban centers.
//                 </p>
//               </div>

//               {/* Key Features */}
//               <div className="grid grid-cols-2 gap-6 mt-12">
//                 {[
//                   { value: '8.7', label: 'Acres of Land' },
//                   { value: '125', label: 'Exclusive Villas' },
//                   { value: '6 km', label: 'From Patancheru' },
//                   { value: '30 km', label: 'From Sangareddy' },
//                 ].map((item, index) => (
//                   <div key={index} className="bg-luxury-bg p-6 rounded-lg">
//                     <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">{item.value}</div>
//                     <p className="text-luxury-primary font-semibold">{item.label}</p>
//                   </div>
//                 ))}
//               </div>
//             </RevealContent>

//             <RevealContent delay={200} className="relative">
//               <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
//                 <RevealImage
//                   src={clubhouse}
//                   alt="Crown Villas"
//                   className="w-full h-full"
//                 />
//               </div>
//               <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-luxury-accent/10 rounded-2xl -z-10"></div>
//               <div className="absolute -top-8 -left-8 w-48 h-48 bg-luxury-primary/10 rounded-full -z-10"></div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* Royal Oak Mention */}
//       <section className="py-20 bg-gradient-to-br from-luxury-accent/10 via-luxury-bg to-luxury-primary/10">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-4xl mx-auto text-center">
//             <RevealContent>
//               <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-12 shadow-xl">
//                 <div className="w-16 h-16 bg-luxury-accent rounded-full flex items-center justify-center mx-auto mb-6">
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//                   </svg>
//                 </div>
//                 <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">Coming Soon: Royal Oak</h3>
//                 <p className="text-lg text-luxury-primary leading-relaxed mb-4">
//                   Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ).
//                 </p>
//                 <p className="text-luxury-primary">
//                   Phase 1 launching soon with premium villa developments.
//                 </p>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* East Facing Villas Section */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//               <RevealContent delay={100} className="space-y-8">
//                 <div>
//                   <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                     EAST ORIENTATION
//                   </span>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
//                     East Facing Villas
//                   </h2>
//                   <p className="text-xl text-luxury-primary/80 leading-relaxed">
//                     East-facing villas are a popular choice for many homeowners, offering abundant morning sunlight and natural brightness.
//                   </p>
//                 </div>

//                 <div className="space-y-6 pt-4">
//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Benefits</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       One of the main benefits of an East-facing villa is that it receives plenty of morning sunlight, which can help to brighten up the interior of the home. This can be especially appealing for those who enjoy starting their day with some natural light. Additionally, East-facing homes often have a cooler temperature, as they are sheltered from the hot afternoon sun.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design Considerations</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       When designing an East-facing villa, it's important to consider the orientation of the home in relation to the sun. Windows and outdoor living spaces should be placed on the East side to take advantage of the morning sun. Shading elements such as awnings or overhangs protect against the hot afternoon sun.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Landscaping & Outdoor Living</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       East-facing villas have beautiful outdoor spaces that can be enjoyed in the morning and early afternoon. This includes patios, decks, and gardens oriented to the East. Landscaping features trees and plants chosen to thrive in morning sun and provide shade in the afternoon.
//                     </p>
//                   </div>
//                 </div>
//               </RevealContent>

//               <RevealContent delay={200} className="relative">
//                 <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
//                   <RevealImage
//                     src={clubhouse2}
//                     alt="East Facing Villa"
//                     className="w-full h-full"
//                   />
//                 </div>
//                 <div className="absolute top-6 right-6 bg-white px-6 py-3 rounded-sm shadow-lg">
//                   <div className="flex items-center gap-3">
//                     <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
//                     </svg>
//                     <span className="font-medium text-luxury-dark">Morning Sun</span>
//                   </div>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* West Facing Villas Section */}
//       <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//               <RevealContent delay={100} className="relative order-2 lg:order-1">
//                 <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
//                   <RevealImage
//                     src={clubhouse3}
//                     alt="West Facing Villa"
//                     className="w-full h-full"
//                   />
//                 </div>
//                 <div className="absolute top-6 left-6 bg-white px-6 py-3 rounded-sm shadow-lg">
//                   <div className="flex items-center gap-3">
//                     <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
//                     </svg>
//                     <span className="font-medium text-luxury-dark">Evening Sun</span>
//                   </div>
//                 </div>
//               </RevealContent>

//               <RevealContent delay={200} className="space-y-8 order-1 lg:order-2">
//                 <div>
//                   <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                     WEST ORIENTATION
//                   </span>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
//                     West Facing Villas
//                   </h2>
//                   <p className="text-xl text-luxury-primary/80 leading-relaxed">
//                     As a company that specializes in building West-facing villas, we have developed a process to ensure that each home meets the highest standards of quality and craftsmanship.
//                   </p>
//                 </div>

//                 <div className="space-y-6 pt-4">
//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design and Planning</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       We work closely with our clients to understand their needs and preferences, creating custom designs that reflect their personal style and meet functional requirements while considering local zoning laws and regulations.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Land Acquisition</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       Once the design is finalized, we work to acquire the land on which it will be built. This may involve purchasing from individual owners or working with developers on larger parcels.
//                     </p>
//                   </div>

//                   <div className="border-l-2 border-luxury-accent/30 pl-6">
//                     <h4 className="font-semibold text-lg text-luxury-dark mb-3">Construction & Finishing</h4>
//                     <p className="text-luxury-primary/80 leading-relaxed">
//                       We use high-quality materials and techniques to ensure longevity. Finishing touches include custom features like hardwood floors, granite countertops, and carefully designed landscaping.
//                     </p>
//                   </div>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Interior Showcase - Green Haven Style */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <RevealContent className="mb-16">
//               <div className="flex items-end justify-between mb-8">
//                 <div>
//                   <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-4">
//                     Crown Villas Interior - Green Haven Style
//                   </h2>
//                   <p className="text-xl text-luxury-primary/70">
//                     Price <span className="font-serif text-3xl font-bold text-luxury-dark ml-2"></span>
//                   </p>
//                 </div>
//                 <button className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-luxury-dark hover:bg-luxury-dark hover:text-white transition-all duration-300 rounded-sm">
//                   <span className="font-medium">View Now</span>
//                   <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                   </svg>
//                 </button>
//               </div>

//               <div className="flex items-center gap-8 text-luxury-primary/70 text-lg flex-wrap">
//                 <span>3,900 sq. ft.</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>3 Bedroom</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>3 Bathroom</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>Sunset View</span>
//                 <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
//                 <span>Swimming Pool</span>
//               </div>
//             </RevealContent>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//               {/* Living Room */}
//               <RevealContent delay={100}>
//                 <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
//                   <RevealImage
//                     src={clubhouse4}
//                     alt="Modern living room with floor-to-ceiling windows"
//                     className="w-full h-full"
//                   />
//                 </div>
//               </RevealContent>

//               {/* Bathroom */}
//               <RevealContent delay={200}>
//                 <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
//                   <RevealImage
//                     src={clubhouse5}
//                     alt="Minimalist bathroom with freestanding tub"
//                     className="w-full h-full"
//                   />
//                 </div>
//               </RevealContent>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Comparison Section */}
//       <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             <RevealContent className="text-center mb-16">
//               <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
//                 COMPARISON
//               </span>
//               <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
//                 East vs West: Making the Right Choice
//               </h2>
//               <p className="text-xl text-luxury-primary/80 max-w-3xl mx-auto">
//                 Understanding the differences to choose your perfect villa
//               </p>
//             </RevealContent>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
//               {[
//                 {
//                   title: 'Sun Exposure',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
//                     </svg>
//                   ),
//                   east: 'Plenty of morning sunlight, brightening interiors and creating a warm, welcoming atmosphere.',
//                   west: 'More afternoon and evening sunlight, creating a warm and cozy atmosphere in the evenings.'
//                 },
//                 {
//                   title: 'Temperature',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                     </svg>
//                   ),
//                   east: 'Often cooler, sheltered from the hot afternoon sun, ideal for comfortable daytime living.',
//                   west: 'Warmer in evenings due to longer periods of afternoon and evening sunlight exposure.'
//                 },
//                 {
//                   title: 'Outdoor Living',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//                     </svg>
//                   ),
//                   east: 'Outdoor spaces oriented to enjoy morning sun, perfect for breakfast and early afternoon activities.',
//                   west: 'Outdoor spaces designed for evening enjoyment, ideal for sunset views and dinner gatherings.'
//                 }
//               ].map((item, index) => (
//                 <RevealContent key={index} delay={100 * (index + 1)}>
//                   <div className="bg-white rounded-sm p-10 hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
//                     <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-8 mx-auto text-luxury-accent">
//                       {item.icon}
//                     </div>
//                     <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-6 text-center">{item.title}</h4>
//                     <div className="space-y-5 flex-grow">
//                       <div>
//                         <p className="font-semibold text-luxury-accent mb-2">East Facing:</p>
//                         <p className="text-luxury-primary/80 text-sm leading-relaxed">{item.east}</p>
//                       </div>
//                       <div>
//                         <p className="font-semibold text-luxury-accent mb-2">West Facing:</p>
//                         <p className="text-luxury-primary/80 text-sm leading-relaxed">{item.west}</p>
//                       </div>
//                     </div>
//                   </div>
//                 </RevealContent>
//               ))}
//             </div>

//             <RevealContent delay={400}>
//               <div className="bg-white rounded-sm p-12">
//                 <p className="text-center text-luxury-primary/90 text-lg leading-relaxed">
//                   <span className="font-semibold text-luxury-dark">Landscaping Tip:</span> Both orientations require thoughtful landscaping with trees and plants chosen to thrive in the appropriate amount of sunlight, ensuring year-round beauty and comfort.
//                 </p>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* Floor Plans Section */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <RevealContent className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Villa Designs
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Floor Plans
//             </h2>
//             <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
//               Detailed drawings that show the layout of each villa, including dimensions, room placements, and the location of doors, windows, and other features.
//             </p>
//           </RevealContent>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
//             {[
//               { title: 'Ground Floor Plan', beds: '3 BHK', size: '2000 sq.ft' },
//               { title: 'First Floor Plan', beds: '4 BHK', size: '2500 sq.ft' },
//               { title: 'Duplex Villa Plan', beds: '5 BHK', size: '3500 sq.ft' },
//             ].map((plan, index) => (
//               <RevealContent key={index} delay={100 * (index + 1)}>
//                 <div className="bg-white rounded-sm overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 group border border-luxury-accent/10 h-full flex flex-col">
//                   <div className="aspect-[4/3] bg-gradient-to-br from-[#E8E2D5] to-white flex items-center justify-center relative overflow-hidden p-8">
//                     {/* Simplified floor plan illustration */}
//                     <div className="w-full h-full border-2 border-luxury-primary/20 rounded-sm relative">
//                       <div className="absolute top-4 left-4 right-4 h-16 border border-luxury-primary/30"></div>
//                       <div className="absolute top-24 left-4 w-20 h-20 border border-luxury-primary/30"></div>
//                       <div className="absolute top-24 right-4 w-20 h-20 border border-luxury-primary/30"></div>
//                       <div className="absolute bottom-4 left-4 right-4 h-24 border border-luxury-primary/30"></div>
//                     </div>
//                     <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-sm shadow-lg">
//                       <span className="text-luxury-accent font-semibold text-sm">{plan.beds}</span>
//                     </div>
//                   </div>
//                   <div className="p-6 flex-grow flex flex-col">
//                     <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{plan.title}</h3>
//                     <div className="flex items-center justify-between text-luxury-primary mb-6">
//                       <span className="text-sm">Built-up Area</span>
//                       <span className="font-semibold">{plan.size}</span>
//                     </div>
//                     <button className="w-full px-6 py-3 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-colors duration-300 mt-auto">
//                       View Details
//                     </button>
//                   </div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>

//           {/* Download Brochure Button */}
//           <RevealContent delay={400} className="text-center mt-16">
//             <button className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//               </svg>
//               Download Complete Brochure
//             </button>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Quality Standards */}
//       <section className="py-20 bg-[#E8E2D5]/30">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-6xl mx-auto">
//             <RevealContent className="text-center mb-16">
//               <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//                 Quality & Craftsmanship
//               </h2>
//               <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
//                 Each home we build meets the highest standards of quality and craftsmanship
//               </p>
//             </RevealContent>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {[
//                 {
//                   title: 'Premium Materials',
//                   desc: 'High-quality materials and construction techniques ensuring durability and longevity',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Custom Designs',
//                   desc: 'Personalized designs that reflect your style while meeting functional requirements',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Expert Team',
//                   desc: 'Skilled engineers and contractors with extensive experience in villa construction',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                   )
//                 },
//                 {
//                   title: 'Thoughtful Landscaping',
//                   desc: 'Beautiful outdoor spaces designed to complement your villa and enhance living experience',
//                   icon: (
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
//                     </svg>
//                   )
//                 },
//               ].map((item, index) => (
//                 <RevealContent key={index} delay={100 * (index + 1)}>
//                   <div className="flex gap-6 bg-white p-8 rounded-sm hover:-translate-y-1 transition-all duration-300 hover:shadow-lg h-full">
//                     <div className="flex-shrink-0 w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center text-luxury-accent">
//                       {item.icon}
//                     </div>
//                     <div>
//                       <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{item.title}</h3>
//                       <p className="text-luxury-primary leading-relaxed">{item.desc}</p>
//                     </div>
//                   </div>
//                 </RevealContent>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10">
//           <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//         </div>

//         <div className="container mx-auto px-4 text-center relative z-10">
//           <RevealContent>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
//               Ready to Own Your Crown Villa?
//             </h2>
//             <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
//               Schedule a site visit today and experience the luxury of The Crown Villas
//             </p>
//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <a
//                 href="/contact"
//                 className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//               >
//                 Schedule Site Visit
//                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                 </svg>
//               </a>
//               <a
//                 href="tel:+919584646464"
//                 className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-sm border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                 </svg>
//                 Call Now
//               </a>
//             </div>
//           </RevealContent>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default CrownVillas;

import React, { useRef, useState, useEffect, useCallback } from 'react';

import gate1 from '../Assets/GATE VIEW -  (1).jpg';
import gate2 from '../Assets/GATE VIEW -  (2).jpg';
import clubhouse from '../Assets/CLUB HOUSE ELVATION -  (1).jpg';
import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';
import clubhouse3 from '../Assets/CLUB HOUSE ELVATION -  (3).jpg';
import clubhouse4 from '../Assets/CLUB HOUSE LANDSCAPE -  (1).jpg';
import clubhouse5 from '../Assets/CLUB HOUSE LANDSCAPE -  (2).jpg';
import clubhouse6 from '../Assets/2.jpg';

// ─── GALLERY IMAGES ─────────────────────────────────────────────────────────────
import landscape1  from '../Assets/LANDSCAPE VIEW - (1).jpg';
import landscape2  from '../Assets/LANDSCAPE VIEW - (2).jpg';
import landscape3  from '../Assets/LANDSCAPE VIEW - (3).jpg';
import landscape4  from '../Assets/LANDSCAPE VIEW - (4).jpg';
import landscape5  from '../Assets/LANDSCAPE VIEW - (5).jpg';
import landscape6  from '../Assets/LANDSCAPE VIEW - (6).jpg';
import landscape7  from '../Assets/LANDSCAPE VIEW - (7).jpg';
import landscape8  from '../Assets/LANDSCAPE VIEW - (8).jpg';
import landscape9  from '../Assets/LANDSCAPE VIEW - (9).jpg';
import landscape10 from '../Assets/LANDSCAPE VIEW - (10).jpg';
import landscape11 from '../Assets/LANDSCAPE VIEW - (11).jpg';
import landscape12 from '../Assets/LANDSCAPE VIEW - (12).jpg';
import landscape13 from '../Assets/LANDSCAPE VIEW - (13).jpg';
import landscape14 from '../Assets/LANDSCAPE VIEW - (14).jpg';
import landscape15 from '../Assets/LANDSCAPE VIEW - (15).jpg';
import landscape16 from '../Assets/LANDSCAPE VIEW - (16).jpg';
import landscape17 from '../Assets/LANDSCAPE VIEW - (17).jpg';
import landscape18 from '../Assets/LANDSCAPE VIEW - (18).jpg';
import landscape19 from '../Assets/LANDSCAPE VIEW - (19).jpg';
import landscape20 from '../Assets/LANDSCAPE VIEW - (20).jpg';
// ────────────────────────────────────────────────────────────────────────────────


const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

// ─── GALLERY LIGHTBOX COMPONENT ────────────────────────────────────────────────
const GalleryLightbox = ({ images, activeIndex, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, onPrev, onNext]);

  if (activeIndex === null) return null;
  const current = images[activeIndex];

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: 'rgba(15, 12, 9, 0.97)' }}
      onClick={onClose}
    >
      {/* Decorative corner lines */}
      <div className="absolute top-6 left-6 w-16 h-16 border-t-2 border-l-2 border-luxury-accent/40 pointer-events-none" />
      <div className="absolute top-6 right-6 w-16 h-16 border-t-2 border-r-2 border-luxury-accent/40 pointer-events-none" />
      <div className="absolute bottom-6 left-6 w-16 h-16 border-b-2 border-l-2 border-luxury-accent/40 pointer-events-none" />
      <div className="absolute bottom-6 right-6 w-16 h-16 border-b-2 border-r-2 border-luxury-accent/40 pointer-events-none" />

      {/* Counter */}
      <div className="absolute top-8 left-1/2 -translate-x-1/2 flex items-center gap-3">
        <div className="w-8 h-[1px] bg-luxury-accent/50" />
        <span className="font-serif text-white/60 text-sm tracking-[0.3em]">
          {String(activeIndex + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}
        </span>
        <div className="w-8 h-[1px] bg-luxury-accent/50"/>
      </div>

      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-24 w-10 h-10 flex items-center justify-center text-white/60 hover:text-luxury-accent transition-colors duration-200 z-10"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Main image */}
      <div
        className="relative max-w-5xl w-full mx-16 flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-full" style={{ maxHeight: '75vh' }}>
          <img
            key={activeIndex}
            src={current.src}
            alt={current.caption}
            className="w-full h-full object-contain"
            style={{
              maxHeight: '75vh',
              animation: 'galleryFadeIn 0.4s cubic-bezier(0.4,0,0.2,1)'
            }}
          />
          {/* Gold accent line top */}
          <div className="absolute top-0 left-0 right-0 h-[2px]"
            style={{ background: 'linear-gradient(90deg, transparent, #C9A96E, transparent)' }}
          />
          {/* Gold accent line bottom */}
          <div className="absolute bottom-0 left-0 right-0 h-[2px]"
            style={{ background: 'linear-gradient(90deg, transparent, #C9A96E, transparent)' }}
          />
        </div>

        {/* Caption */}
        <div className="mt-5 text-center">
          <p className="text-white/50 text-xs uppercase tracking-[0.35em] font-medium">{current.category}</p>
          <h4 className="font-serif text-white text-xl mt-1">{current.caption}</h4>
        </div>
      </div>

      {/* Navigation arrows */}
      <button
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center border border-white/20 text-white/70 hover:border-luxury-accent hover:text-luxury-accent transition-all duration-300 hover:scale-110"
        style={{ backdropFilter: 'blur(8px)', background: 'rgba(255,255,255,0.05)' }}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center border border-white/20 text-white/70 hover:border-luxury-accent hover:text-luxury-accent transition-all duration-300 hover:scale-110"
        style={{ backdropFilter: 'blur(8px)', background: 'rgba(255,255,255,0.05)' }}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={(e) => { e.stopPropagation(); /* set index via parent */ }}
            className={`transition-all duration-300 rounded-full ${
              i === activeIndex
                ? 'w-6 h-[3px] bg-luxury-accent'
                : 'w-[6px] h-[6px] bg-white/30 hover:bg-white/60'
            }`}
          />
        ))}
      </div>

      <style>{`
        @keyframes galleryFadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to   { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

// ─── GALLERY SECTION COMPONENT ─────────────────────────────────────────────────
const GallerySection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [filter, setFilter] = useState('All');
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const galleryImages = [
    // ── Exterior ────────────────────────────────────────────────────────────
    { src: gate1,        caption: 'Grand Entrance Gate',        category: 'Exterior',  size: 'large' },
    { src: gate2,        caption: 'Gate View at Dusk',          category: 'Exterior',  size: 'small' },
    // ── Clubhouse ───────────────────────────────────────────────────────────
    { src: clubhouse,    caption: 'Club House Elevation I',     category: 'Clubhouse', size: 'wide'  },
    { src: clubhouse2,   caption: 'Club House Elevation II',    category: 'Clubhouse', size: 'small' },
    { src: clubhouse3,   caption: 'Club House Elevation III',   category: 'Clubhouse', size: 'small' },
    { src: clubhouse4,   caption: 'Club House Landscape I',     category: 'Clubhouse', size: 'small' },
    { src: clubhouse5,   caption: 'Club House Landscape II',    category: 'Clubhouse', size: 'small' },
    // ── Landscape ───────────────────────────────────────────────────────────
    { src: landscape1,   caption: 'Lush Green Pathways',        category: 'Landscape', size: 'large' },
    { src: landscape2,   caption: 'Open Air Promenade',         category: 'Landscape', size: 'small' },
    { src: landscape3,   caption: 'Garden Retreat',             category: 'Landscape', size: 'small' },
    { src: landscape4,   caption: 'Verdant Courtyard',          category: 'Landscape', size: 'wide'  },
    { src: landscape5,   caption: 'Evening Landscape',          category: 'Landscape', size: 'small' },
    { src: landscape6,   caption: 'Sunrise Over the Greens',    category: 'Landscape', size: 'small' },
    { src: landscape7,   caption: 'Tranquil Water Feature',     category: 'Landscape', size: 'large' },
    { src: landscape8,   caption: 'Tree-Lined Boulevard',       category: 'Landscape', size: 'small' },
    { src: landscape9,   caption: 'Open Meadow View',           category: 'Landscape', size: 'small' },
    { src: landscape10,  caption: 'Poolside Landscape',         category: 'Landscape', size: 'wide'  },
    { src: landscape11,  caption: 'Nature\'s Canopy',           category: 'Landscape', size: 'small' },
    { src: landscape12,  caption: 'Manicured Garden Walk',      category: 'Landscape', size: 'small' },
    { src: landscape13,  caption: 'Dusk Horizon',               category: 'Landscape', size: 'large' },
    { src: landscape14,  caption: 'Scenic Overlook',            category: 'Landscape', size: 'small' },
    { src: landscape15,  caption: 'Community Green Space',      category: 'Landscape', size: 'small' },
    { src: landscape16,  caption: 'Botanical Corner',           category: 'Landscape', size: 'wide'  },
    { src: landscape17,  caption: 'Morning Mist Pathway',       category: 'Landscape', size: 'small' },
    { src: landscape18,  caption: 'Elevated Garden Terrace',    category: 'Landscape', size: 'small' },
    { src: landscape19,  caption: 'Golden Hour Vista',          category: 'Landscape', size: 'large' },
    { src: landscape20,  caption: 'Royal Grounds Panorama',     category: 'Landscape', size: 'wide'  },
  ];

  const categories = ['All', 'Landscape', 'Exterior', 'Clubhouse'];

  const filtered = filter === 'All'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  const openLightbox = (i) => setActiveIndex(i);
  const closeLightbox = () => setActiveIndex(null);
  const goPrev = useCallback(() => setActiveIndex(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);
  const goNext = useCallback(() => setActiveIndex(i => (i + 1) % filtered.length), [filtered.length]);

  return (
    <section className="py-24 lg:py-36 relative overflow-hidden" style={{ background: '#0F0C09' }}>
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full opacity-[0.04]"
          style={{ background: 'radial-gradient(circle, #C9A96E, transparent)' }} />
        <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full opacity-[0.04]"
          style={{ background: 'radial-gradient(circle, #C9A96E, transparent)' }} />
        {/* Fine grid pattern */}
        <div className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: 'linear-gradient(rgba(201,169,110,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(201,169,110,0.5) 1px, transparent 1px)',
            backgroundSize: '60px 60px'
          }}
        />
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Header */}
        <RevealContent className="text-center mb-16">
          {/* Roman numeral decoration */}
          <p className="font-serif text-luxury-accent/20 text-8xl font-bold mb-[-3rem] select-none" aria-hidden>IV</p>

          <div className="relative inline-block">
            <span className="block text-xs font-semibold uppercase tracking-[0.4em] text-luxury-accent/70 mb-4">
              Visual Journey
            </span>
            <h2 className="font-serif text-5xl lg:text-7xl font-bold leading-tight"
              style={{ color: '#F5F0E8' }}>
              Project Gallery
            </h2>
            {/* Decorative underline */}
            <div className="flex items-center justify-center gap-3 mt-5">
              <div className="h-[1px] w-16" style={{ background: 'linear-gradient(to right, transparent, #C9A96E)' }} />
              <div className="w-2 h-2 rotate-45 bg-luxury-accent" />
              <div className="h-[1px] w-16" style={{ background: 'linear-gradient(to left, transparent, #C9A96E)' }} />
            </div>
          </div>

          <p className="mt-6 text-white/40 text-lg max-w-xl mx-auto font-light leading-relaxed">
            A curated glimpse into the architecture, landscape, and soul of The Crown Villas
          </p>
        </RevealContent>

        {/* Filter tabs */}
        <RevealContent delay={100} className="flex justify-center gap-2 mb-12 flex-wrap">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => { setFilter(cat); setActiveIndex(null); }}
              className={`px-6 py-2 text-sm uppercase tracking-[0.2em] font-medium transition-all duration-300 border ${
                filter === cat
                  ? 'bg-luxury-accent text-white border-luxury-accent shadow-lg'
                  : 'bg-transparent text-white/40 border-white/10 hover:border-luxury-accent/50 hover:text-white/70'
              }`}
            >
              {cat}
            </button>
          ))}
        </RevealContent>

        {/* ── Masonry / Editorial Grid ───────────────────────────────────────── */}
        <RevealContent delay={150}>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 auto-rows-[200px]">
            {filtered.map((img, i) => {
              const spanClass =
                img.size === 'large' ? 'col-span-2 row-span-2' :
                img.size === 'wide'  ? 'col-span-2 row-span-1' :
                                       'col-span-1 row-span-1';

              return (
                <div
                  key={`${filter}-${i}`}
                  className={`${spanClass} relative group cursor-pointer overflow-hidden`}
                  onClick={() => openLightbox(i)}
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{ animation: `galleryItemIn 0.6s cubic-bezier(0.4,0,0.2,1) ${i * 60}ms both` }}
                >
                  {/* Image */}
                  <img
                    src={img.src}
                    alt={img.caption}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                  />

                  {/* Gradient overlay - always visible at bottom */}
                  <div className="absolute inset-0 transition-opacity duration-500"
                    style={{
                      background: 'linear-gradient(to top, rgba(15,12,9,0.85) 0%, rgba(15,12,9,0.2) 50%, transparent 100%)',
                      opacity: hoveredIndex === i ? 1 : 0.6
                    }}
                  />

                  {/* Category chip */}
                  <div
                    className="absolute top-3 left-3 px-3 py-1 text-[10px] uppercase tracking-[0.25em] font-semibold transition-all duration-300"
                    style={{
                      background: 'rgba(201,169,110,0.15)',
                      backdropFilter: 'blur(8px)',
                      border: '1px solid rgba(201,169,110,0.3)',
                      color: '#C9A96E',
                      opacity: hoveredIndex === i ? 1 : 0,
                      transform: hoveredIndex === i ? 'translateY(0)' : 'translateY(-8px)',
                    }}
                  >
                    {img.category}
                  </div>

                  {/* Caption + zoom icon */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between">
                    <div className="flex-1">
                      <p className="font-serif text-white font-medium text-sm lg:text-base leading-tight
                        transition-all duration-500"
                        style={{
                          opacity: hoveredIndex === i ? 1 : 0,
                          transform: hoveredIndex === i ? 'translateY(0)' : 'translateY(10px)'
                        }}
                      >
                        {img.caption}
                      </p>
                      <p className="text-white/50 text-[11px] uppercase tracking-[0.2em] mt-1
                        transition-all duration-500 delay-75"
                        style={{
                          opacity: hoveredIndex === i ? 1 : 0,
                          transform: hoveredIndex === i ? 'translateY(0)' : 'translateY(10px)'
                        }}
                      >
                        The Crown Villas
                      </p>
                    </div>

                    {/* Zoom icon */}
                    <div
                      className="w-9 h-9 flex items-center justify-center border border-white/30 text-white ml-3 flex-shrink-0 transition-all duration-400"
                      style={{
                        opacity: hoveredIndex === i ? 1 : 0,
                        transform: hoveredIndex === i ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
                        background: 'rgba(201,169,110,0.2)',
                        backdropFilter: 'blur(4px)',
                      }}
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                      </svg>
                    </div>
                  </div>

                  {/* Corner accent on hover */}
                  <div className="absolute top-0 right-0 w-8 h-8 transition-all duration-400"
                    style={{
                      borderTop: '2px solid #C9A96E',
                      borderRight: '2px solid #C9A96E',
                      opacity: hoveredIndex === i ? 1 : 0,
                      transform: hoveredIndex === i ? 'scale(1)' : 'scale(0)',
                      transformOrigin: 'top right'
                    }}
                  />
                  <div className="absolute bottom-0 left-0 w-8 h-8 transition-all duration-400"
                    style={{
                      borderBottom: '2px solid #C9A96E',
                      borderLeft: '2px solid #C9A96E',
                      opacity: hoveredIndex === i ? 1 : 0,
                      transform: hoveredIndex === i ? 'scale(1)' : 'scale(0)',
                      transformOrigin: 'bottom left'
                    }}
                  />

                  {/* Serial number watermark */}
                  <div className="absolute top-3 right-3 font-serif text-white/10 text-5xl font-bold pointer-events-none select-none leading-none">
                    {String(i + 1).padStart(2, '0')}
                  </div>
                </div>
              );
            })}
          </div>
        </RevealContent>

        {/* Bottom strip - count & CTA */}
        <RevealContent delay={300} className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-white/10 pt-10">
          <div>
            <p className="text-white/25 text-xs uppercase tracking-[0.35em] mb-1">Total Captures</p>
            <p className="font-serif text-white/70 text-4xl font-bold">
              {String(galleryImages.length).padStart(2, '0')}
              <span className="text-luxury-accent text-lg ml-1">+</span>
            </p>
          </div>

          <div className="flex items-center gap-4">
            {/* Thumbnail strip */}
            <div className="hidden md:flex items-center gap-2">
              {galleryImages.slice(0, 8).map((img, i) => (
                <div
                  key={i}
                  onClick={() => { setFilter('All'); setActiveIndex(i); }}
                  className="w-10 h-10 overflow-hidden cursor-pointer opacity-40 hover:opacity-100 transition-all duration-300 border border-transparent hover:border-luxury-accent/50"
                >
                  <img src={img.src} alt="" className="w-full h-full object-cover" />
                </div>
              ))}
              <span className="text-white/30 text-sm ml-1">+{galleryImages.length - 8} more</span>
            </div>

            <button
              onClick={() => { setFilter('All'); openLightbox(0); }}
              className="inline-flex items-center gap-3 px-8 py-3 border border-luxury-accent/40 text-luxury-accent text-sm uppercase tracking-[0.2em] font-semibold hover:bg-luxury-accent hover:text-white transition-all duration-300 hover:shadow-lg"
              style={{ boxShadow: 'none' }}
            >
              View All
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>
        </RevealContent>
      </div>

      {/* Lightbox */}
      {activeIndex !== null && (
        <GalleryLightbox
          images={filtered}
          activeIndex={activeIndex}
          onClose={closeLightbox}
          onPrev={goPrev}
          onNext={goNext}
        />
      )}

      <style>{`
        @keyframes galleryItemIn {
          from { opacity: 0; transform: translateY(30px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)   scale(1);    }
        }
      `}</style>
    </section>
  );
};
// ────────────────────────────────────────────────────────────────────────────────


const CrownVillas = () => {
  return (
    <div className="crown-villas">
      {/* Premium Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#E8E2D5]">
        <div className="container mx-auto px-4 lg:px-8 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-7xl mx-auto mb-20">
            {/* Left - Hillside Villa */}
            <RevealContent delay={100}>
              <div className="relative aspect-[4/5] rounded-none overflow-hidden shadow-2xl">
                <RevealImage
                  src={gate1}
                  alt="The Crown Villas - East Facing"
                  className="w-full h-full"
                />
              </div>
            </RevealContent>

            {/* Right - Oceanfront Villa */}
            <RevealContent delay={200}>
              <div className="relative aspect-[16/10] rounded-none overflow-hidden shadow-2xl">
                <RevealImage
                  src={gate2}
                  alt="The Crown Villas - West Facing"
                  className="w-full h-full"
                />
              </div>
            </RevealContent>
          </div>

          {/* Hero Content */}
          <div className="max-w-7xl mx-auto">
        <RevealContent delay={300} className="text-center mb-12">
  <div className="mb-6">
    <div className="inline-block w-20 h-[2px] bg-luxury-accent mx-auto"></div>
  </div>
  <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
    The Crown Villas
  </h1>

  <div className="relative mx-auto mb-6 max-w-2xl px-4">
    {/* Outer glow */}
    <div className="absolute inset-0 bg-gradient-to-r from-amber-400/30 via-yellow-300/20 to-amber-400/30 blur-xl rounded-sm"></div>
    {/* Card */}
    <div className="relative bg-white border border-amber-300/60 shadow-[0_4px_32px_rgba(217,180,91,0.18)] rounded-sm px-8 py-6 w-full">

      {/* Top ornament */}
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-amber-400/70"></div>
        <svg className="w-2 h-2 text-amber-400 rotate-45 shrink-0" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12"/></svg>
        <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-amber-400/70"></div>
      </div>

      <div className="text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-500/80 font-medium mb-3">Presenting</p>

        <div className="overflow-visible py-2">
          <p className="font-serif text-4xl lg:text-5xl font-bold leading-tight pb-2"
            style={{ background: "linear-gradient(to right, #d97706, #eab308, #d97706)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
            130 Exclusive Villas
          </p>
        </div>

        <div className="flex items-center justify-center gap-3 my-3">
          <div className="h-[1px] w-10 bg-gradient-to-r from-transparent to-amber-400/70"></div>
          <svg className="w-2 h-2 text-amber-400 rotate-45" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12"/></svg>
          <div className="h-[1px] w-10 bg-gradient-to-l from-transparent to-amber-400/70"></div>
        </div>

        <div className="overflow-visible py-2">
          <p className="font-serif text-3xl lg:text-4xl font-semibold leading-tight pb-2"
            style={{ background: "linear-gradient(to right, #d97706, #eab308, #d97706)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
            Spread Across 9 Acres
          </p>
        </div>
      </div>

      {/* Bottom ornament */}
      <div className="flex items-center justify-center gap-3 mt-4">
        <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-amber-400/70"></div>
        <svg className="w-2 h-2 text-amber-400 rotate-45 shrink-0" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12"/></svg>
        <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-amber-400/70"></div>
      </div>

    </div>
  </div>

  <div className="flex items-center justify-center gap-3 mb-6">
    <div className="h-[1px] w-12 bg-gradient-to-r from-transparent to-amber-400/60"></div>
    <svg className="w-3 h-3 text-amber-400 rotate-45" fill="currentColor" viewBox="0 0 24 24">
      <rect x="9" y="9" width="6" height="6" />
    </svg>
    <div className="h-[1px] w-12 bg-gradient-to-l from-transparent to-amber-400/60"></div>
  </div>

  <p className="text-xl text-luxury-primary/70 max-w-3xl mx-auto leading-relaxed tracking-wide">
    Rameshwar Banda Village, Patancheru Mandal, Sangareddy District
  </p>
</RevealContent>

            {/* Premium Financing Badge */}
          <RevealContent delay={400} className="flex justify-center">
  <div className="relative group">
    <div className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-luxury-primary opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300"></div>
    <div className="relative bg-white border border-luxury-accent/20 rounded-sm p-6 hover:shadow-2xl transition-all duration-300">
      <div className="text-center">
        <p className="text-luxury-primary/60 text-xs uppercase tracking-[0.2em] mb-2 font-medium">
          Project Financed By
        </p>
        <h3 className="font-serif text-lg font-semibold text-luxury-dark mb-2">
          Capri Global Capital Limited
        </h3>
        <div className="inline-flex items-center gap-1.5 bg-luxury-accent/10 px-4 py-1.5 rounded-sm">
          <svg className="w-3 h-3 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <p className="text-luxury-accent font-medium uppercase text-xs tracking-wider">
            Authorized Financial Partner
          </p>
        </div>
      </div>
    </div>
  </div>
</RevealContent>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-luxury-primary/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
            <RevealContent delay={100}>
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                About The Project
              </span>
              <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
                Experience<br />Royal Living
              </h2>
              <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
                <p>
                  The Crown Villas project is an 9 acre development of 130 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. Today it is a calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy, which is the District Headquarters.
                </p>
                <p>
                  This prestigious development offers a perfect blend of tranquility and accessibility, providing residents with a serene living environment while maintaining convenient connectivity to major urban centers.
                </p>
              </div>

              {/* Key Features */}
              <div className="grid grid-cols-2 gap-6 mt-12">
                {[
                  { value: '9', label: 'Acres of Land' },
                  { value: '130', label: 'Exclusive Villas' },
                  { value: '6 km', label: 'From Patancheru' },
                  { value: '30 km', label: 'From Sangareddy' },
                ].map((item, index) => (
                  <div key={index} className="bg-luxury-bg p-6 rounded-lg">
                    <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">{item.value}</div>
                    <p className="text-luxury-primary font-semibold">{item.label}</p>
                  </div>
                ))}
              </div>
            </RevealContent>

            <RevealContent delay={200} className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
                <RevealImage
                  src={clubhouse6}
                  alt="Crown Villas"
                  className="w-full h-full"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-luxury-accent/10 rounded-2xl -z-10"></div>
              <div className="absolute -top-8 -left-8 w-48 h-48 bg-luxury-primary/10 rounded-full -z-10"></div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Royal Oak Mention */}
      <section className="py-20 bg-gradient-to-br from-luxury-accent/10 via-luxury-bg to-luxury-primary/10">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <RevealContent>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-12 shadow-xl">
                <div className="w-16 h-16 bg-luxury-accent rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">Coming Soon: Royal Oak</h3>
                <p className="text-lg text-luxury-primary leading-relaxed mb-4">
                  Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ).
                </p>
                <p className="text-luxury-primary">
                  Phase 1 launching soon with premium villa developments.
                </p>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* East Facing Villas Section */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <RevealContent delay={100} className="space-y-8">
                <div>
                  <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                    EAST ORIENTATION
                  </span>
                  <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
                    East Facing Villas
                  </h2>
                  <p className="text-xl text-luxury-primary/80 leading-relaxed">
                    East-facing villas are a popular choice for many homeowners, offering abundant morning sunlight and natural brightness.
                  </p>
                </div>

                <div className="space-y-6 pt-4">
                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Benefits</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      One of the main benefits of an East-facing villa is that it receives plenty of morning sunlight, which can help to brighten up the interior of the home. This can be especially appealing for those who enjoy starting their day with some natural light. Additionally, East-facing homes often have a cooler temperature, as they are sheltered from the hot afternoon sun.
                    </p>
                  </div>

                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design Considerations</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      When designing an East-facing villa, it's important to consider the orientation of the home in relation to the sun. Windows and outdoor living spaces should be placed on the East side to take advantage of the morning sun. Shading elements such as awnings or overhangs protect against the hot afternoon sun.
                    </p>
                  </div>

                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Landscaping & Outdoor Living</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      East-facing villas have beautiful outdoor spaces that can be enjoyed in the morning and early afternoon. This includes patios, decks, and gardens oriented to the East. Landscaping features trees and plants chosen to thrive in morning sun and provide shade in the afternoon.
                    </p>
                  </div>
                </div>
              </RevealContent>

              <RevealContent delay={200} className="relative">
              <div className="aspect-[4/5] w-full lg:w-[520px] xl:w-[620px] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">

                  <RevealImage
                    src={clubhouse2}
                    alt="East Facing Villa"
                    className="w-full h-full"
                  />
                </div>
                <div className="absolute top-6 right-6 bg-white px-6 py-3 rounded-sm shadow-lg">
                  <div className="flex items-center gap-3">
                    <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                    <span className="font-medium text-luxury-dark">Morning Sun</span>
                  </div>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* West Facing Villas Section */}
      <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <RevealContent delay={100} className="relative order-2 lg:order-1">
                {/* <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]"> */}
                <div className="aspect-[4/5] w-full lg:w-[520px] xl:w-[620px] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">

                  <RevealImage
                    src={clubhouse3}
                    alt="West Facing Villa"
                    className="w-full h-full"
                  />
                </div>
                <div className="absolute top-6 left-6 bg-white px-6 py-3 rounded-sm shadow-lg">
                  <div className="flex items-center gap-3">
                    <svg className="w-6 h-6 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                    </svg>
                    <span className="font-medium text-luxury-dark">Evening Sun</span>
                  </div>
                </div>
              </RevealContent>

              <RevealContent delay={200} className="space-y-8 order-1 lg:order-2">
                <div>
                  <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                    WEST ORIENTATION
                  </span>
                  <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
                    West Facing Villas
                  </h2>
                  <p className="text-xl text-luxury-primary/80 leading-relaxed">
                    As a company that specializes in building West-facing villas, we have developed a process to ensure that each home meets the highest standards of quality and craftsmanship.
                  </p>
                </div>

                <div className="space-y-6 pt-4">
                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Design and Planning</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      We work closely with our clients to understand their needs and preferences, creating custom designs that reflect their personal style and meet functional requirements while considering local zoning laws and regulations.
                    </p>
                  </div>

                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Land Acquisition</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      Once the design is finalized, we work to acquire the land on which it will be built. This may involve purchasing from individual owners or working with developers on larger parcels.
                    </p>
                  </div>

                  <div className="border-l-2 border-luxury-accent/30 pl-6">
                    <h4 className="font-semibold text-lg text-luxury-dark mb-3">Construction & Finishing</h4>
                    <p className="text-luxury-primary/80 leading-relaxed">
                      We use high-quality materials and techniques to ensure longevity. Finishing touches include custom features like hardwood floors, granite countertops, and carefully designed landscaping.
                    </p>
                  </div>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Interior Showcase - Green Haven Style */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="mb-16">
              <div className="flex items-end justify-between mb-8">
                <div>
                  <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-4">
                    Crown Villas Interior - Green Haven Style
                  </h2>
                  <p className="text-xl text-luxury-primary/70">
                    Price <span className="font-serif text-3xl font-bold text-luxury-dark ml-2"></span>
                  </p>
                </div>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-luxury-dark hover:bg-luxury-dark hover:text-white transition-all duration-300 rounded-sm">
                  <span className="font-medium">View Now</span>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>

              <div className="flex items-center gap-8 text-luxury-primary/70 text-lg flex-wrap">
                <span>3,900 sq. ft.</span>
                <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
                <span>3 Bedroom</span>
                <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
                <span>3 Bathroom</span>
                <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
                <span>Sunset View</span>
                <span className="w-1 h-1 bg-luxury-accent/50 rounded-full"></span>
                <span>Swimming Pool</span>
              </div>
            </RevealContent>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Living Room */}
              <RevealContent delay={100}>
                <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
                  <RevealImage
                    src={clubhouse4}
                    alt="Modern living room with floor-to-ceiling windows"
                    className="w-full h-full"
                  />
                </div>
              </RevealContent>

              {/* Bathroom */}
              <RevealContent delay={200}>
                <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-xl group">
                  <RevealImage
                    src={clubhouse5}
                    alt="Minimalist bathroom with freestanding tub"
                    className="w-full h-full"
                  />
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="text-center mb-16">
              <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                COMPARISON
              </span>
              <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
                East vs West: Making the Right Choice
              </h2>
              <p className="text-xl text-luxury-primary/80 max-w-3xl mx-auto">
                Understanding the differences to choose your perfect villa
              </p>
            </RevealContent>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              {[
                {
                  title: 'Sun Exposure',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  ),
                  east: 'Plenty of morning sunlight, brightening interiors and creating a warm, welcoming atmosphere.',
                  west: 'More afternoon and evening sunlight, creating a warm and cozy atmosphere in the evenings.'
                },
                {
                  title: 'Temperature',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  ),
                  east: 'Often cooler, sheltered from the hot afternoon sun, ideal for comfortable daytime living.',
                  west: 'Warmer in evenings due to longer periods of afternoon and evening sunlight exposure.'
                },
                {
                  title: 'Outdoor Living',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  ),
                  east: 'Outdoor spaces oriented to enjoy morning sun, perfect for breakfast and early afternoon activities.',
                  west: 'Outdoor spaces designed for evening enjoyment, ideal for sunset views and dinner gatherings.'
                }
              ].map((item, index) => (
                <RevealContent key={index} delay={100 * (index + 1)}>
                  <div className="bg-white rounded-sm p-10 hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
                    <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-8 mx-auto text-luxury-accent">
                      {item.icon}
                    </div>
                    <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-6 text-center">{item.title}</h4>
                    <div className="space-y-5 flex-grow">
                      <div>
                        <p className="font-semibold text-luxury-accent mb-2">East Facing:</p>
                        <p className="text-luxury-primary/80 text-sm leading-relaxed">{item.east}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-luxury-accent mb-2">West Facing:</p>
                        <p className="text-luxury-primary/80 text-sm leading-relaxed">{item.west}</p>
                      </div>
                    </div>
                  </div>
                </RevealContent>
              ))}
            </div>

            <RevealContent delay={400}>
              <div className="bg-white rounded-sm p-12">
                <p className="text-center text-luxury-primary/90 text-lg leading-relaxed">
                  <span className="font-semibold text-luxury-dark">Landscaping Tip:</span> Both orientations require thoughtful landscaping with trees and plants chosen to thrive in the appropriate amount of sunlight, ensuring year-round beauty and comfort.
                </p>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Floor Plans Section */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <RevealContent className="text-center mb-16">
            <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
              Villa Designs
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
              Floor Plans
            </h2>
            <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
              Detailed drawings that show the layout of each villa, including dimensions, room placements, and the location of doors, windows, and other features.
            </p>
          </RevealContent>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { title: 'Ground Floor Plan', beds: '3 BHK', size: '2000 sq.ft' },
              { title: 'First Floor Plan', beds: '4 BHK', size: '2500 sq.ft' },
              { title: 'Duplex Villa Plan', beds: '5 BHK', size: '3500 sq.ft' },
            ].map((plan, index) => (
              <RevealContent key={index} delay={100 * (index + 1)}>
                <div className="bg-white rounded-sm overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 group border border-luxury-accent/10 h-full flex flex-col">
                  <div className="aspect-[4/3] bg-gradient-to-br from-[#E8E2D5] to-white flex items-center justify-center relative overflow-hidden p-8">
                    {/* Simplified floor plan illustration */}
                    <div className="w-full h-full border-2 border-luxury-primary/20 rounded-sm relative">
                      <div className="absolute top-4 left-4 right-4 h-16 border border-luxury-primary/30"></div>
                      <div className="absolute top-24 left-4 w-20 h-20 border border-luxury-primary/30"></div>
                      <div className="absolute top-24 right-4 w-20 h-20 border border-luxury-primary/30"></div>
                      <div className="absolute bottom-4 left-4 right-4 h-24 border border-luxury-primary/30"></div>
                    </div>
                    <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-sm shadow-lg">
                      <span className="text-luxury-accent font-semibold text-sm">{plan.beds}</span>
                    </div>
                  </div>
                  <div className="p-6 flex-grow flex flex-col">
                    <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{plan.title}</h3>
                    <div className="flex items-center justify-between text-luxury-primary mb-6">
                      <span className="text-sm">Built-up Area</span>
                      <span className="font-semibold">{plan.size}</span>
                    </div>
                    <button className="w-full px-6 py-3 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-colors duration-300 mt-auto">
                      View Details
                    </button>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>

          {/* Download Brochure Button */}
          <RevealContent delay={400} className="text-center mt-16">
            <button className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download Complete Brochure
            </button>
          </RevealContent>
        </div>
      </section>

      {/* Quality Standards */}
      <section className="py-20 bg-[#E8E2D5]/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <RevealContent className="text-center mb-16">
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
                Quality & Craftsmanship
              </h2>
              <p className="text-lg text-luxury-primary max-w-3xl mx-auto">
                Each home we build meets the highest standards of quality and craftsmanship
              </p>
            </RevealContent>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  title: 'Premium Materials',
                  desc: 'High-quality materials and construction techniques ensuring durability and longevity',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  )
                },
                {
                  title: 'Custom Designs',
                  desc: 'Personalized designs that reflect your style while meeting functional requirements',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                    </svg>
                  )
                },
                {
                  title: 'Expert Team',
                  desc: 'Skilled engineers and contractors with extensive experience in villa construction',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  )
                },
                {
                  title: 'Thoughtful Landscaping',
                  desc: 'Beautiful outdoor spaces designed to complement your villa and enhance living experience',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                  )
                },
              ].map((item, index) => (
                <RevealContent key={index} delay={100 * (index + 1)}>
                  <div className="flex gap-6 bg-white p-8 rounded-sm hover:-translate-y-1 transition-all duration-300 hover:shadow-lg h-full">
                    <div className="flex-shrink-0 w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center text-luxury-accent">
                      {item.icon}
                    </div>
                    <div>
                      <h3 className="font-serif text-xl font-bold text-luxury-dark mb-3">{item.title}</h3>
                      <p className="text-luxury-primary leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PROJECT GALLERY SECTION ─────────────────────────────────────────── */}
      <GallerySection />

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <RevealContent>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
              Ready to Own Your Crown Villa?
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
              Schedule a site visit today and experience the luxury of The Crown Villas
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                Schedule Site Visit
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </a>
              <a
                href="tel:+919584646464"
                className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-sm border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Call Now
              </a>
            </div>
          </RevealContent>
        </div>
      </section>
    </div>
  );
};

export default CrownVillas;